import {
  FieldSwitchSmall as Bool,
  FieldColorSmall as Color,
  FieldEmailSmall as Email,
  FieldLinkSmall as Link,
  FieldNumberSmall as Number,
  FieldOptionSmall as Option,
  FieldPhoneSmall as Phone,
  FieldTextSmall as PlainText,
  FieldVideoSmall as Video,
} from '@packages/systems/ui/icons';
import type {FieldType} from '@packages/systems/dynamo/records/Field';

const Icons = {
  Bool,
  Color,
  Email,
  Link,
  Number,
  Option,
  Phone,
  PlainText,
  Video,
} as const;

/**
 * Get an icon for a CMS field type
 */
export const getIcon = (field: FieldType) => {
  if (Icons.hasOwnProperty(field.type)) {
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly Bool: (props: IconProps) => ReactElement<SVGProps<SVGElement>, string | JSXElementConstructor<any>>; ... 7 more ...; readonly Video: (props: IconProps) => ReactElement<...>; }'.
    return Icons[field.type];
  }

  return null;
};
